export const jobsData = [
    {
        title: "React + Node.js Fullstack Developer Trainer (1- 2 year experience)",

        value: "React + Node.js Fullstack Developer Trainer",

        name: "React + Node.js (1-2yr exp only) Developer Trainer - (2 years minimum working + Must submit original certificates)",

        overview: "We are looking for a React + Node.js Full Stack Developer with minimum 1 year of experience to build and maintain scalable web applications.The candidate should have good knowledge of frontend and backend development, database management, and API integration. ",

        responsibilities: [
            "Develop responsive and user-friendly interfaces using React.js ",
            "Build and maintain backend services using Node.js and Express.js",
            "Design and manage databases (MongoDB / MySQL)",
            "Develop and integrate RESTful APIs ",
            "Write clean, efficient, and maintainable code",
            "Debug, troubleshoot, and maintain existing applications",
            "Ensure application performance, security, and scalability",
            "Should be proactive, organized, and capable of handling multitasking responsibilities",
            "Must be flexible and willing to learn new technologies and processes",

        ],

        workDetails: [
            "Office Timing: 10:00 AM – 7:00 PM",
            "Saturday is a working day",
            "Work From Office – Coimbatore"
        ],

        requiredSkills: [
            "Strong knowledge of React.js ",
            "Good understanding of Node.js and Express.js",
            "Experience with MongoDB or MySQL",
            "Knowledge of REST API development",
            "Understanding of HTML5, CSS3, JavaScript(ES6+)",
            "Experience with Git version control",

        ],
        prefferredSkills: [
            "Knowledge of Redux or Context API",
            "Experience with JWT authentication",
            "Basic knowledge of Docker or CI/CD pipelines",
        ],
        requirements: [
            "Selected candidates must submit their 10th original marksheet at the time of joining.",
            "Candidates must be willing to serve a 2-year service agreement."
        ]

    },
    {
        title: "HR & Admin - Female (0 -1 year experience)",

        value: "HR & Admin - Female",

        name: "HR & Admin (0-1yr exp / Female only) - (2 years minimum working + Must submit original certificates)",

        overview: "We are looking for an HR & Admin Executive with 0-1 year of experience to support daily HR operations and administrative tasks. The candidate will assist in recruitment coordination, employee record management, office administration, and internal communication.",

        responsibilities: [
            " Assist in recruitment coordination and interview scheduling ",
            " Maintain employee records and HR documentation ",
            " Support attendance, leave management, and HR coordination ",
            " Handle office administration and day - to - day operational tasks ",
            " Assist in internal communication and team coordination ",
            " Support accounts - related and administrative work ",
            " Assist in Business Development activities and tele - calling to clients ",
            " Handle multi - tasking responsibilities across Business Development, Accounts, HR, and Admin functions ",
            " Should be proactive, organized, and capable of handling multitasking responsibilities",
            " Must be flexible and willing to learn different operational processes",
        ],

        requiredSkills: [
            "Good communication and interpersonal skills",
            "Strong organizational and time management abilities",
            "Ability to handle multiple tasks and prioritize work",
            "Basic knowledge of MS Office (Word, Excel)",
            "Good documentation and record management skills",
            "Ability to work in a team and coordinate with different departments",
            "Proactive attitude and willingness to learn",
        ],

        workDetails: [
            "Office Timing: 10:00 AM – 7:00 PM",
            "Saturday is a working day",
            "Work From Office – Coimbatore"
        ],
        requirements: [
            "Selected candidates must submit their 10th original marksheet at the time of joining.",
            "Candidates must be willing to serve a 2-year service agreement."
        ]

    }
];
